import {
  LayoutDashboard,
  Database,
  Globe,
  Sparkles,
  Users,
  Megaphone,
  TrendingUp,
  Bot,
  Plane,
  Tag,
  Settings,
} from "lucide-react";

export const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", path: "/dashboard", status: "active", icon: LayoutDashboard },
  { id: "data-hub", label: "Data Hub", path: "/data-hub", status: "active", icon: Database },
  { id: "markets", label: "Markets", path: "/markets", status: "active", icon: Globe },
  { id: "opportunities", label: "Opportunities", path: "/opportunities", status: "active", icon: Sparkles },
  { id: "partners", label: "Partners", path: "/partners", status: "active", icon: Users },
  { id: "campaigns", label: "Campaigns", path: "/campaigns", status: "active", icon: Megaphone },
  { id: "performance", label: "Performance", path: "/performance", status: "active", icon: TrendingUp },
  { id: "ask-lodge", label: "Ask Lodge", path: "/ask-lodge", status: "active", icon: Bot },
  { id: "gsa-worldwide", label: "GSA Worldwide", path: "/gsa-worldwide", status: "active", icon: Plane },
  { id: "pricing", label: "Pricing", path: "/pricing", status: "active", icon: Tag },
  { id: "settings", label: "Settings", path: "/settings", status: "active", icon: Settings },
];
